import { render, staticRenderFns } from "./TableProvincias.vue?vue&type=template&id=439ace8e&scoped=true"
import script from "./TableProvincias.vue?vue&type=script&lang=js"
export * from "./TableProvincias.vue?vue&type=script&lang=js"
import style0 from "./TableProvincias.vue?vue&type=style&index=0&id=439ace8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ace8e",
  null
  
)

export default component.exports